import React from 'react'
import WidgetMakerHeader from '../../components/Widget/WidgetMakerHeader'
import { StyleSheet, css } from 'aphrodite'
import LayoutCol from '../../components/Layout/LayoutCol'
import { useTranslation } from 'react-i18next'
import UIButton from '../../components/UI/UIButton'
import { useNavigate } from 'react-router-dom'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: '32px',
    '@media(max-width: 800px)': {
      textAlign: 'center',
    },
    '@media(max-width: 600px)': {
      fontSize: '24px',
      paddingLeft: '40px',
      paddingRight: '40px',
    },
  },
  textDesc: {
    fontSize: '1em',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '50px',
    marginTop: '84px',
    '@media(max-width: 600px)': {
      marginTop: '50px',
      flexDirection: 'column-reverse',
      gap: '30px',
    },
  },
  dynamicStyle: {
    '@media(max-width: 600px)': {
      width: '100%',
      maxWidth: '100%',
      flex: 1,
      padding: '22px',
    },
  },
  description: {
    '@media(max-width: 600px)': {
      fontWeight: 600,
      fontSize: '14px',
      textAlign: 'center',
    },
  },
  invoiceButtonDynamicStyle: {
    marginTop: '20px',
    marginBottom: '20px',
    '@media(max-width: 600px)': {
      fontSize: '10px',
    },
  },
  buttonCreateRequest: {
    '@media(max-width: 600px)': {
      height: '34px',
      borderRadius: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  buttonAccount: {
    '@media(max-width: 600px)': {
      height: '46px',
      borderRadius: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
})

export default function EndLIve() {
  const { t } = useTranslation('endLive')

  const navigate = useNavigate()
  return (
    <>
      <WidgetMakerHeader
        handleBecomeMakerClick={() => {}}
        handleGlobeClick={function noRefCheck() {}}
      />
      <div className={css(styles.container)}>
        <LayoutCol dynamicStyle={styles.dynamicStyle} col={5}>
          <h1 className={css(styles.title)}>{t('title')}</h1>
          <p className={css(styles.description)}>{t('description')}</p>
          <p className={css(styles.textDesc)}>
            {t('descriptionWithButton1')}{' '}
            <span
              className={css(styles.link)}
              onClick={() => {
                navigate('/account/invoice')
              }}
            >
              &quot;{t('buttonInvoicesLabel')}&quot;
            </span>{' '}
            {t('descriptionWithButton2')}
          </p>
          <div className={css(styles.buttonContainer)}>
            <UIButton
              design="invertedTertiary"
              label={t('accountButonLabel')}
              onClick={() => {
                navigate('/account')
              }}
              dynamicStyle={styles.buttonAccount}
            />
            <UIButton
              onClick={() => {
                navigate('/create-request')
              }}
              design="tertiary"
              label={t('requestButtonLable')}
              dynamicStyle={styles.buttonCreateRequest}
            />
          </div>
        </LayoutCol>
      </div>
    </>
  )
}
